import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddGroup({ open, onClose, setOpen }: ModalProps) {
    const [feeType, setFeeType] = useState("Transaction Fee");
    const [amountType, setAmountType] = useState("Percentage");
    const handleFeeTypeChange = (event: SelectChangeEvent) => {
        setFeeType(event.target.value);
    };

    const handleAmountTypeChange = (event: SelectChangeEvent) => {
        setAmountType(event.target.value);
    };

    return (
        <Modal className="modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Group</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Fee Code */}
                            <div className="control_group">
                                <label htmlFor="group-name">Group Name</label>
                                <TextField
                                    placeholder="Enter Group Name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "group-name" }}
                                />
                            </div>

                           
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                             <img src="/static/images/ai_icon.svg" alt="icon" />   Enhance With AI
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Add Group
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
